"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureUpdater = void 0;
class BrowserFeaturePostUpdater {
    post(url, update) {
        return new Promise((resolve) => {
            const req = new XMLHttpRequest();
            req.open('PUT', url);
            req.setRequestHeader('Content-type', 'application/json');
            req.send(JSON.stringify(update));
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    resolve(req.status >= 200 && req.status < 300);
                }
            };
        });
    }
}
class FeatureUpdater {
    constructor(config) {
        this.sdkUrl = config.url();
        this.manager = FeatureUpdater.featureUpdaterProvider();
    }
    updateKey(key, update) {
        return this.manager.post(this.sdkUrl + '/' + key, update);
    }
}
exports.FeatureUpdater = FeatureUpdater;
FeatureUpdater.featureUpdaterProvider = () => new BrowserFeaturePostUpdater();
//# sourceMappingURL=test_sdk.js.map